const state = {
    characterStauts: false,
}
const getters = {
    characterStauts: state => state.characterStauts,
}

const mutations = {
    setCharacterStauts(state, data) {
        state.characterStauts = data.state
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations
};




// WEBPACK FOOTER //
// ./src/store/modules/resourcesArea/characterContent.js